import(/* webpackMode: "eager" */ "/poc-codegiant/components/site-header.tsx")